var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel"},[_c('owl-carousel',{attrs:{"items":_vm.owlItems,"opts":_vm.owlOptions,"ocid":_vm.owlId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }